<template>
  <div class="container">
    <div class="row">
      <div class="row__name">默认文字颜色</div>
      <div class="row__content flex jc-start">
        <el-switch v-model="controls.defaultFontColor"></el-switch>
        <div class="row-item-tip">(开启默认颜色将基于形状色域赋值)</div>
      </div>
    </div>

    <div class="row">
      <div class="row__name">形状透明度</div>
      <div class="row__content flex jc-start">
        <slider
          ref="transparence"
          :partNum="100"
          :max="100"
          :numFixed="0"
          :suffix="'%'"
          @slideEnd="onSlideEndTransparence"
        ></slider>
      </div>
    </div>

    <div class="row">
      <div class="row__name">词数</div>
      <div class="row__content">
        <slider
          ref="wordCount"
          :partNum="60"
          :max="600"
          @slideEnd="onSlideEndWordCount"
        ></slider>
      </div>
    </div>

    <div class="row">
      <div class="row__name">词间距</div>
      <div class="row__content">
        <slider
          ref="wordMargin"
          :partNum="50"
          :max="50"
          :suffix="'px'"
          @slideEnd="onSlideEndWordMargin"
        ></slider>
      </div>
    </div>

    <div
      class="row"
      v-show="!controls.bgTransparent"
    >
      <div class="row__name">背景颜色</div>
      <div class="row__content">
        <div
          class="color-trigger"
          @click.stop="
            showColorPicker($event, controls.colorHex);
            $analysis('word_cloud,click_style_bgcolor，文字云_点击_样式_背景颜色');
          "
          :style="{backgroundColor: controls.colorHex}"
        ></div>
      </div>
    </div>

    <div class="row">
      <div class="row__name">背景颜色透明</div>
      <div class="row__content flex jc-start">
        <el-switch v-model="controls.bgTransparent"></el-switch>
      </div>
    </div>

    <!-- <div class="row">
      <div class="row__name">背景透明度</div>
      <div class="row__content flex jc-start">
        <slider ref="transparenceBg"
          :partNum="100"
          :max="100"
          :numFixed="0"
          :suffix="'%'"
          @slideEnd="onSlideEndTransparenceBg"
        ></slider>
      </div>
    </div>-->

    <div
      class="row"
      v-show="!controls.bgTransparent"
    >
      <div class="row__name">透明通道</div>
      <div class="row__content flex jc-start">
        <el-switch v-model="controls.isAlpha"></el-switch>
        <!-- <div class="row-item-tip">(开启默认颜色将基于形状色域赋值)</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import slider from './sliderCloud.vue';

export default {
  components: {
    slider
  },
  data () {
    let defControls = {
      defaultFontColor: false,
      transparence: 65,
      wordCount: 100,
      wordMargin: 10,
      colorHex: '#ffffff',
      bgTransparent: false,
      isAlpha: true
    };
    return {
      controls: {
        ...defControls
      },
      defControls: {
        ...defControls
      }
    };
  },
  computed: {
    ...mapGetters([
      'TopnavMsg'
    ])
  },
  watch: {
    'TopnavMsg.isShowWordCloudDialog' (val) {
      if (val) {
        this.$refs.transparence.setValue(this.controls.transparence);
        this.$refs.wordCount.setValue(this.controls.wordCount);
        this.$refs.wordMargin.setValue(this.controls.wordMargin);
      }
    },
    'controls.defaultFontColor': {
      handler (val) {
        this.$bus.emit('worlCloud.defaultFontColor', val);
        if (val) {
          this.$analysis('word_cloud,click_style_default_color，文字云_点击_开启默认颜色');
        }
      },
      immediate: true
    },
    'controls.bgTransparent': {
      handler (val) {
        if (val) {
          this.$analysis('word_cloud,click_style_bgcolor_transparent，文字云_点击_样式_背景颜色透明');
        } else {
          this.$analysis('word_cloud,click_style_bgcolor_cancel_transparent，文字云_点击_样式_取消背景颜色透明');
        }
      },
      // immediate: true
    },
    'controls.isAlpha': {
      handler (val) {
        if (val) {
          this.$analysis('word_cloud,click_style_alpha_channel，文字云_点击_样式_设置透明通道');
        } else {
          this.$analysis('word_cloud,click_style_cancel_alpha_channel，文字云_点击_样式_取消透明通道');
        }
      },
      // immediate: true
    }
  },
  created () {
    this.$bus.on('textControl.getStyleControl', (comp) => {
      comp.styleControl = this.getControls();
    });

    this.$bus.on(`cloud.colorPickerConfirm`, (obj, data) => {
      if (data.from === 'styleControl') {
        this.controls.colorHex = obj.hex;
      }
    });
  },
  methods: {
    onSlideEndTransparence (val) {
      this.controls.transparence = val;
    },
    onSlideEndWordCount (val) {
      this.controls.wordCount = val;
    },
    onSlideEndWordMargin (val) {
      this.controls.wordMargin = val;
    },
    getControls () {
      return this.controls;
    },
    reset () {
      this.controls = {
        ...this.defControls
      };
    },

    showColorPicker (ev, color = '#ffffff', from) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color-cloud',
        // 使用了mixins popup.vue 下两字段就非必传
        posx: rect.left + rect.width,
        posy: rect.top - 150,
        type: 1,
        hasEyedropper: false,
        color: color,
        from: from || 'styleControl'
      });
    },

    onSlideEndTransparenceBg () {

    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 38px;
  padding-left: 29px;
}
.row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;

  &__name {
    width: 70px;
    white-space: nowrap;
    margin-right: 2em;
    text-align: left;
  }

  &__content {
    width: 455px;
  }
}

.radio {
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border: solid 1px #5778fb;
  border-radius: 14px;

  &__inner {
    width: 8px;
    height: 8px;
    background-color: #fff;
    border: solid 1px #fff;
    border-radius: 14px;
  }

  &.active {
    &__inner {
      background-color: #5778fb;
      border: solid 1px #5778fb;
    }
  }
}

.flex {
  display: flex;
}
.jc-start {
  justify-content: flex-start;
}

.row-item-tip {
  margin-left: 2em;
  color: #7a7a7a;
}

.color-trigger {
  height: 30px;
  width: 100px;
  border: 1px solid #666;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/styleControl.vue